<template>
   <b-container fluid class="article-details">

      <b-row v-if="apiError">
         <b-col>
            <b-alert variant="warning" show>{{ apiError }}</b-alert>
         </b-col>
      </b-row>
      <spinner v-if="loadingArticle"></spinner>
      <transition name="fade">
         <div v-if="article && !loadingArticle">
            <b-container>
               <b-row class="article-row">
                  <b-col md="6">
                     <ImageGallery ref="gallery" :images="imageList"/>
                  </b-col>
                  <b-col v-if="isApproved" md="6">
                     <pb-btn v-if="canRead('DEBUG_WINDOW') && !loadingGtlArticle"
                             style="position: absolute;right: 0; top: 0; z-index: 1001"
                             v-b-modal.debugModal class="text-center mb-2">
                        DEBUG INFO
                     </pb-btn>
                     <div
                         v-bind:class="[{ busy: loadingPrice }, 'article-info', 'text-center', 'opacity-transition', 'mb-5']">
                        <spinner v-if="loadingPrice"></spinner>
                        <h3 class="my-3">{{ article.primaryDescription || article.secondaryDescription }}
                        </h3>
                        <div class="info-box d-block">
                           <b-row>
                              <b-col class="text-right">
                                 <b>Item number</b>
                              </b-col>
                              <b-col class="text-left">
                                 <b-row>
                                    <b-col>
                                       {{ article.name }}&nbsp;
                                    </b-col>
                                 </b-row>
                                 <b-row v-if="customerArticleNumber">
                                    <b-col>
                                       {{ customerArticleNumber }}<br>
                                    </b-col>
                                 </b-row>
                                 <b-row>
                                    <b-col>

                                    </b-col>
                                 </b-row>
                              </b-col>
                           </b-row>
                           <b-row v-if="selectedVariant">
                              <b-col class="text-right">
                                 <span class="icon-gts"></span>
                              </b-col>
                              <b-col class="text-left">
                                 <b-row>
                                    <b-col>

                                       <nobr>
                                          <b-link target="_blank"
                                                  :href="`https://gts.pranke.com/itemview?Nav=40&TypeS=ArticleDetail&Field=Sku&Search=DE.LAU.PET-BUE.0000-${selectedVariant.variationId}-0000`">
                                             DE.LAU.PET-BUE.0000-{{ selectedVariant.variationId }}-0000
                                          </b-link>
                                       </nobr>
                                    </b-col>
                                 </b-row>
                              </b-col>
                           </b-row>
                           <b-row v-if="articlePrice && user" class="text-left">
                              <b-col class="text-right">
                                 <b>Available stock</b>
                              </b-col>
                              <b-col class="text-left" v-if="articlePrice.calculatedStock > 0">
                                 {{ articlePrice.calculatedStock }}
                                 <!--                                           <br>
                                                                             <div class="text-red"
                                                                                  v-if="articlePrice.calculatedStock > 0 && isBasicShop"><b>20% on sample
                                                                                 price for units on stock</b></div>-->
                              </b-col>
                              <b-col class="text-left text-success"
                                     v-else-if="selectedVariant && selectedVariant.neverOutOfStock">
                                 goods are already under production
                              </b-col>
                              <b-col class="text-left" v-else>
                                 samples available on request
                              </b-col>
                           </b-row>
                           <b-row v-if="articlePrice && (rawComponents > 0)" class="text-left">
                              <b-col class="text-right">
                                 <b>raw components</b>
                              </b-col>
                              <b-col class="text-left">
                                 {{ rawComponents }}
                              </b-col>
                           </b-row>
                        </div>
                        <div v-if="articlePrice && user && selectedVariant">
                           <table v-if="showForeignCurrency && !hasRole('EX-Istanbul-Preise')" :key="selectedVariant.variationId"
                                  class="price-block price-table mt-3 text-left">
                              <tr style="font-size: 14px;font-weight: bold;">
                                 <td></td>
                                 <td class="px-2">
                                    <nobr>exw Laufach</nobr>
                                 </td>
                                 <td>
                                    <nobr>exw HKG</nobr>
                                 </td>
                              </tr>
                              <tr v-if="(sampleThreshold !== 0 || articlePrice.samplePrice !== articlePrice.price)"
                                  class="my-1">
                                 <td class="text-right px-2 width-50">
                                    from {{ sampleThreshold }} {{ article.quantityUnit }}
                                 </td>
                                 <td v-if="articlePrice.samplePrice > 0.0" class="text-left px-2">
                                    <nobr>{{
                                          articlePrice.samplePrice |
                                              currency($currencyFormatting[articlePrice.currency])
                                       }}
                                    </nobr>
                                 </td>
                                 <td v-if="articlePrice.samplePrice > 0.0">
                                                <span v-if="articlePrice.samplePriceForeignCurrency > 0"><nobr>{{
                                                      articlePrice.samplePriceForeignCurrency |
                                                          currency($currencyFormatting[articlePrice.currencyCodeForeignCurrency])
                                                   }}</nobr></span>
                                    per {{ article.priceUnit }} {{ article.quantityUnit }}
                                    <!--                                               <span
                                                                                    class="alert-square font-sm p-1"
                                                                                    v-if="articlePrice.calculatedStock > 0 && isBasicShop">20%</span>-->
                                 </td>
                                 <td v-else class="text-left px-2">
                                    price on request
                                 </td>
                              </tr>
                              <tr v-if="(article.bulkpriceThreshold !== 0 || articlePrice.samplePrice !== articlePrice.price)">
                                 <td class="text-right px-2 width-50">
                                    from {{ article.bulkpriceThreshold }} {{ article.quantityUnit }}
                                 </td>
                                 <td v-if="articlePrice.price > 0.0" class="text-left px-2">
                                    {{
                                       articlePrice.price |
                                           currency($currencyFormatting[articlePrice.currency])
                                    }}
                                 </td>
                                 <td v-if="articlePrice.price > 0.0">
                                                <span v-if="articlePrice.priceForeignCurrency > 0">{{
                                                      articlePrice.priceForeignCurrency |
                                                          currency($currencyFormatting[articlePrice.currencyCodeForeignCurrency])
                                                   }}</span>
                                    per
                                    {{ article.priceUnit }} {{ article.quantityUnit }}
                                 </td>
                                 <td v-else class="text-left px-2">
                                    price on request
                                 </td>
                              </tr>
                              <tr v-if="articlePrice.price > 0.0">
                                 <td></td>
                                 <td colspan="2" class="text-left px-2">
                                    <small class="text-left d-block">Price valid until: {{
                                          new
                                          Date(article.priceValidTo).toLocaleDateString()
                                       }}
                                    </small>
                                 </td>
                              </tr>
                           </table>
                           <table v-else :key="selectedVariant.variationId"
                                  class="price-block price-table mt-3">
                              <tr v-if="hasRole('EX-Istanbul-Preise')" style="font-size: 14px;font-weight: bold;">
                                 <td></td>
                                 <td class="px-2 text-left">
                                    <nobr >ex Istanbul</nobr>
                                 </td>
                              </tr>
                              <tr v-if="(sampleThreshold !== 0 || articlePrice.samplePrice !== articlePrice.price)"
                                  class="text-left my-1">
                                 <td class="text-right px-2 width-50">
                                    from {{ sampleThreshold }} {{ article.quantityUnit }}
                                 </td>
                                 <td v-if="articlePrice.samplePrice > 0.0" class="text-left px-2">
                                    {{
                                       articlePrice.samplePrice |
                                           currency($currencyFormatting[articlePrice.currency])
                                    }}
                                    per {{ article.priceUnit }} {{ article.quantityUnit }}
                                    <!--                                               <span
                                                                                    class="alert-square font-sm p-1"
                                                                                    v-if="articlePrice.calculatedStock > 0 && isBasicShop">20%</span>-->
                                 </td>
                                 <td v-else class="text-left px-2">
                                    price on request
                                 </td>
                              </tr>
                              <tr v-if="(article.bulkpriceThreshold !== 0 || articlePrice.samplePrice !== articlePrice.price)">
                                 <td class="text-right px-2 width-50">
                                    from {{ article.bulkpriceThreshold }} {{ article.quantityUnit }}
                                 </td>
                                 <td v-if="articlePrice.price > 0.0" class="text-left px-2">
                                    {{
                                       articlePrice.price |
                                           currency($currencyFormatting[articlePrice.currency])
                                    }} per
                                    {{ article.priceUnit }} {{ article.quantityUnit }}
                                    <small class="text-left d-block">price valid till: {{
                                          new
                                          Date(article.priceValidTo).toLocaleDateString()
                                       }}
                                    </small>
                                 </td>
                                 <td v-else class="text-left px-2">
                                    price on request
                                 </td>
                              </tr>
                           </table>
                        </div>
                     </div>

                     <b-row>
                        <b-col class="border-right border-secondary" v-if="user">
                           <nobr>
                              <pb-btn v-b-popover.hover.top="'Add or Remove from Favorites'"
                                      :busy="loadingFavorites"

                                      :icon="isInFavorites ? 'fas fa-heart' : 'fa-heart'"
                                      class="d-block m-auto lg"
                                      @click.native="addToFavorites()"
                                      variant="link">

                              </pb-btn>
                           </nobr>
                        </b-col>
                        <b-col class="border-right border-secondary">
                           <nobr>
                              <b-button v-b-popover.hover.top="'Article Details'"
                                        class="d-block m-auto lg article-details-toggle-btn"
                                        v-b-toggle.article-details-toggle variant="link"><i
                                  class="fal fa-lg fa-info-square fa-inline"></i><i
                                  class="when-closed fal fa-lg fa-minus fa-inline"></i><i
                                  class="when-opened fal fa-lg fa-plus fa-inline"></i></b-button>
                           </nobr>
                        </b-col>
                        <b-col
                            v-if="user">
                           <nobr>
                              <pb-btn v-b-popover.hover.top="'Stock Information'" :busy="loadingVariantList"
                                      icon="fa-table"
                                      class="d-block m-auto lg article-details-toggle-btn"
                                      v-b-toggle.article-stock-toggle
                                      variant="link">
                                 <i
                                     class="when-closed fal fa-lg fa-minus fa-inline"></i><i
                                  class="when-opened fal fa-lg fa-plus fa-inline"></i>
                              </pb-btn>
                           </nobr>
                        </b-col>
                        <b-col
                            v-bind:class="['border-left', { 'border-right border-secondary': isSampleRequestEnabled() }]">
                           <pb-btn v-b-popover.hover.top="'Order List'" :busy="loadingOrderList"
                                   icon="fa-list-ul"
                                   class=" m-auto border-secondary d-block"
                                   @click.native="loadOrderList()"
                                   variant="link">
                           </pb-btn>
                        </b-col>
                        <b-col class="text-center" v-if="isSampleRequestEnabled()">
                           <div id="sample-disabled" class="d-inline-block">
                              <nobr>
                                 <pb-btn v-b-popover.hover.top="'Add to Samples'" :busy="busyAddingSample"
                                         icon="fa-swatchbook"
                                         :disabled="inSampleList"
                                         class="d-block m-auto lg"
                                         @click.native="onRequestSample()"
                                         variant="link">

                                 </pb-btn>
                              </nobr>
                           </div>
                        </b-col>
                        <b-popover v-if="inSampleList" triggers="hover"
                                   target="sample-disabled"
                                   variant="warning"
                                   placement="top">
                           Article variant is already in your sample list
                        </b-popover>
                     </b-row>
                     <b-row>
                        <b-col>
                           <b-collapse id="article-stock-toggle" :visible="stockVisible && !loadingVariantList"
                                       ref="articleStockToggle"
                                       class="mt-2 article-stock-collapsible border-0 p-2">
                              <pb-article-stock-table v-if="colorSizeMatrix && colorSizeMatrix.length > 0"
                                                      @select-variant="selectVariant"
                                                      :colorSizeMatrix="colorSizeMatrix"></pb-article-stock-table>
                           </b-collapse>
                           <b-collapse ref="articleDetailsToggle" id="article-details-toggle"
                                       @show="toggleDetails()" :visible="detailsVisible"
                                       class="mt-2 article-details-collapsible border-0 p-2">
                              <pb-article-details-table :article="article"
                                                        :variant="selectedVariant"></pb-article-details-table>

                              <div class="mt-4" v-if="!loadingGtlArticle && gtlAttributes.length > 0 ">
                                 <h5 class="text-center mb-2">BUTTON FEATURES<br><small>(in
                                    GTSL-Standard)</small></h5>
                                 <div>
                                    <div :key="key" v-for="(item,key) in gtlAttributes">
                                       <div class="mb-2">

                                          <h6>{{ item.description }}</h6>
                                          <div :key="childKey"
                                               v-for="(child,childKey) in item.attributes">
                                             <b-row style="font-size: 13px;" align-v="top">
                                                <b-col offset-md="1" md="6">
                                                   {{ child.feature.description }}:
                                                </b-col>
                                                <b-col v-if="!child.valueEntity">
                                                   {{ child.value }}
                                                </b-col>
                                                <b-col v-else>
                                                   {{ child.valueEntity.description }}
                                                </b-col>
                                                <b-col md="auto" class="text-right px-2 ">
                                                   <img v-if="!child.valueEntity"
                                                        style="max-height: 28px; margin:auto;"
                                                        @error="$event.target.style.display='none'"
                                                        :src="'https://gts.pranke.com/pictures/' + child.feature.id"/>
                                                   <img v-else style="max-height: 26px; margin:auto;"
                                                        @error="$event.target.style.display='none'"
                                                        :src="'https://gts.pranke.com/pictures/' + child.valueEntity.id"/>
                                                </b-col>
                                             </b-row>

                                          </div>
                                       </div>
                                       <!--                                                    <b-row v-if="item.articleAttribute">-->
                                       <!--                                                        <b-col md="7">-->
                                       <!--                                                            <span style="font-weight: bold;" v-if="item.childNodes && item.childNodes.length > 0"> {{ item.articleAttribute.feature.description }}:</span>-->
                                       <!--                                                            <span v-else> {{ item.articleAttribute.feature.description }}:</span>-->
                                       <!--                                                        </b-col>-->
                                       <!--                                                        <b-col v-if="!item.articleAttribute.valueEntity">-->
                                       <!--                                                            {{ item.articleAttribute.value }}-->
                                       <!--                                                        </b-col>-->
                                       <!--                                                        <b-col v-else>-->
                                       <!--                                                            {{ item.articleAttribute.valueEntity.description }}-->
                                       <!--                                                        </b-col>-->
                                       <!--                                                        <b-col align-self="end" class="text-right">-->
                                       <!--                                                            <img style="width: 32px; height: 32px; margin:auto;" @error="$event.target.style.display='none'" :src="'https://gts.pranke.com/pictures/' + item.featureId"/>-->
                                       <!--                                                        </b-col>-->
                                       <!--                                                    </b-row>-->
                                       <!--                                                    <b-row v-else-if="item.childNodes && item.childNodes.length > 0">-->
                                       <!--                                                        <b-col>-->
                                       <!--                                                            <b>{{item.feature.description}}</b>-->
                                       <!--                                                        </b-col>-->
                                       <!--                                                        <b-col align-self="end" class="text-right">-->
                                       <!--                                                            <img style="width: 32px; height: 32px; margin:auto;" @error="$event.target.style.display='none'" :src="'https://gts.pranke.com/pictures/' + item.featureId"/>-->

                                       <!--                                                        </b-col>-->
                                       <!--                                                    </b-row>-->
                                       <!--                                                    <div class="mb-2" v-if="item.childNodes && item.childNodes.length > 0">-->
                                       <!--                                                        <div :key="childKey" v-for="(child,childKey) in item.childNodes">-->
                                       <!--                                                            <b-row v-if="child.articleAttribute">-->
                                       <!--                                                                <b-col offset-md="1" md="6">-->
                                       <!--                                                                    {{ child.articleAttribute.feature.description }}:-->
                                       <!--                                                                </b-col>-->
                                       <!--                                                                <b-col v-if="!child.articleAttribute.valueEntity">-->
                                       <!--                                                                    {{ child.articleAttribute.value }}-->
                                       <!--                                                                </b-col>-->
                                       <!--                                                                <b-col v-else>-->
                                       <!--                                                                    {{ child.articleAttribute.valueEntity.description }}-->
                                       <!--                                                                </b-col>-->
                                       <!--                                                                <b-col align-self="end" class="text-right">-->
                                       <!--                                                                    <img style="width: 32px; height: 32px; margin:auto;" @error="$event.target.style.display='none'" :src="'https://gts.pranke.com/pictures/' + child.articleAttribute.feature.id"/>-->
                                       <!--                                                                </b-col>-->
                                       <!--                                                            </b-row>-->
                                       <!--                                                        </div>-->

                                       <!--                                                    </div>-->
                                    </div>
                                 </div>

                              </div>
                           </b-collapse>
                        </b-col>
                     </b-row>
                     <b-row class="my-2">
                        <b-col>
                           <CustomSelect class="border-bottom border-top border-secondary"
                                         @select="onSelectSize"
                                         :value="selectedSize" label="SIZE"
                                         inline-label="Size:"
                                         :key="selectedSize"
                                         :options="sizeOptions"></CustomSelect>
                           <CustomSelect class="border-bottom border-secondary" @select="onSelectColor"
                                         :value="selectedColor" label="COLOR"
                                         :key="selectedColor"
                                         inline-label="Color:"
                                         :options="colorOptions">
                              <template slot="prefix">
                                 <div v-if="showSelectCustomerModeSwitch" title="Customer Color Names"
                                      style="position: absolute; left: 5px; font-size: 20px;"
                                      @click.stop="toggleColorSelectMode">
                                    <i v-if="colorSelectCustomerMode" class="fal fa-toggle-on"></i>
                                    <i v-else class="fal fa-toggle-off"></i>
                                 </div>
                              </template>
                           </CustomSelect>
                        </b-col>
                     </b-row>
                     <div v-if="!user" class="text-center d-block mt-3">
                        More details and options are available for
                        <b-button variant="primary" class="text-center" v-b-modal.registrationModal>
                           REGISTERED
                        </b-button>
                        users only.
                     </div>
                     <b-row class="mt-4" v-if="articlePrice && user">
                        <b-col md="3">
                           <div id="popover-sample-event">
                              <b-form-input
                                  :disabled="isPurchaseLocked && (this.articlePrice.samplePrice <= 0.0 && this.articlePrice.price <= 0.0)"
                                  id="amount"
                                  size="lg"
                                  class="text-center secondary"
                                  type="number"
                                  min="1"
                                  step="1"
                                  name="amount"
                                  placeholder="QUANTITY"
                                  v-model="amount"
                                  v-validate="amountValidationRule"
                                  :state="validateState('amount')">
                              </b-form-input>
                           </div>
                        </b-col>
                        <b-col md="9">
                           <div id="popover-button-event">
                              <pb-btn :busy="submitProcessing"
                                      :disabled="isPurchaseLocked"
                                      icon="fa-plus" block
                                      v-on:click.native="onAddToCart()"
                                      size="lg"
                                      variant="primary">
                                 ADD TO BAG
                              </pb-btn>
                           </div>
                        </b-col>

                        <b-popover
                            v-if="(this.articlePrice.samplePrice <= 0.0 && this.articlePrice.price <= 0.0)"
                            triggers="hover" target="popover-sample-event"
                            variant="warning"
                            placement="top">
                                    <span>
                                        {{ $t("invalid_pricing") }}
                                    </span>
                        </b-popover>
                        <b-popover v-if="isPurchaseLocked" triggers="hover" target="popover-button-event"
                                   variant="warning"
                                   placement="top">
                                    <span v-if="this.articlePrice.samplePrice <= 0.0 && this.articlePrice.price <= 0.0">
                                        {{ $t("invalid_pricing") }}
                                    </span>
                        </b-popover>
                     </b-row>
                     <b-row v-if="errors.first('amount') && !isBasicShop && (amount && amount > 0)">
                        <b-col class="my-2">
                           <span class="text-red">{{ $t("invalid_article_amount_customer_shop") }}</span>
                        </b-col>
                     </b-row>
                     <b-row v-else-if="errors.first('amount')">
                        <b-col class="my-2">
                           <span class="text-red">{{ $t("invalid_article_amount") }}</span>
                        </b-col>
                     </b-row>
                     <b-row class="px-2 mt-2" v-if="article.note">
                        <b-col>
                           {{ article.note }}
                        </b-col>
                     </b-row>
                     <b-row class="mt-2 article-document-section">
                        <b-col>
                           <b-row v-if="user">
                              <b-col>
                                 <b-button variant="link" :disabled="loadingExport || !selectedColor"
                                           @click.prevent.stop="loadArticlePdf">
                                    <b-spinner class="mx-2"
                                               v-if="loadingExport" small/>
                                    <i v-else
                                       class="fal fa-2x fa-file-pdf"></i>&nbsp;PDF Export
                                 </b-button>
                              </b-col>
                           </b-row>
                           <b-row v-if="link3D">
                              <b-col>
                                 <b-button variant="link"
                                           :href="link3D" target="_blank"><i
                                     class="fal fa-2x fa-cube"></i>&nbsp;3D Model
                                 </b-button>
                              </b-col>
                           </b-row>
                           <b-row :key="index" v-for="(file,index) in article.articleFileList">
                              <b-col>
                                 <b-button variant="link"
                                           v-if="(/\.(gif|jpg|jpeg|tiff|png)$/i).test(file.fileName)"
                                           :href="fileResourceUrl(file)"
                                           target="_blank"><i
                                     class="fal fa-2x fa-image"></i>&nbsp;{{ file.fileLabel }}
                                 </b-button>
                                 <b-button variant="link" v-else-if="(/\.(mp4)$/i).test(file.fileName)"
                                           :href="fileResourceUrl(file)"
                                           target="_blank"><i
                                     class="fal fa-2x fa-file-video"></i>&nbsp;{{ file.fileLabel }}
                                 </b-button>
                                 <b-button variant="link" v-else
                                           :href="fileResourceUrl(file)"
                                           target="_blank"><i
                                     class="fal fa-2x fa-file-spreadsheet"></i>&nbsp;{{ file.fileLabel }}
                                 </b-button>
                              </b-col>
                           </b-row>
                        </b-col>
                     </b-row>
                  </b-col>
                  <b-col v-else md="6">
                     <h3 class="text-center my-3">{{
                           article.primaryDescription ||
                           article.secondaryDescription
                        }}</h3>
                     <div class="info-box d-block">
                        <b-row>
                           <b-col class="text-right">
                              <b>Item number</b>
                           </b-col>
                           <b-col class="text-left">
                              <b-row>
                                 <b-col>
                                    {{ article.name }}
                                 </b-col>
                              </b-row>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col class="my-4 text-center">
                              Article details are currently getting created.
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col class="text-center">
                              <pb-btn v-b-modal.contactModal class="text-center mb-2"
                                      @click.native="$refs.contactModal.resetData()"
                                      icon="fa-envelope"
                                      variant="secondary">
                                 REQUEST MORE INFORMATION
                              </pb-btn>
                           </b-col>
                        </b-row>
                        <contact-modal
                            ref="contactModal"
                            id="contactModal"
                            :article="article"
                            :subject="contactSubject">
                        </contact-modal>
                     </div>
                  </b-col>
               </b-row>
            </b-container>
            <pb-related-articles v-if="category" :article="article"
                                 :category="category"
                                 key="article.id"
                                 id="relatedArticles"/>
            <pb-related-moods v-if="canRead('collection_moods')" :article="article"
                              id="relatedMoods"/>
            <sample-confirmation-modal :category="category"
                                       id="sample-confirmation-modal"
                                       ref="sampleConfirmationModal"/>
            <debug-modal v-if="canRead('DEBUG_WINDOW') && !loadingGtlArticle" id="debugModal" :category="category"
                         :article="article"
                         :variant="selectedVariant"
                         ref="debugModal"></debug-modal>
            <b-modal ref="orderPositionsModal" size="xl" title="Order List" ok-only>

               <b-row align-v="end">
                  <b-col md="10">
                     <b-row>
                        <b-col md="2">
                           <b>Article:</b>
                        </b-col>
                        <b-col md="auto">
                           {{ customerArticleNumber }}
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="2">
                           <b>PB Article:</b>
                        </b-col>
                        <b-col md="auto">
                           {{ this.article.name }}
                        </b-col>
                     </b-row>
                  </b-col>
                  <b-col>
                     <b-form-input id="search"
                                   name="search"
                                   placeholder="Search"
                                   v-model="orderListFilter"
                                   class="secondary search-input"/>
                  </b-col>
               </b-row>


               <br>

               <b-table v-if="orderList && orderList.length > 0" responsive striped small hover
                        :items="orderList"
                        :filter="orderListFilter"
                        :fields="[
                                {key: 'orderCreatedAt', label: 'Order Date'},
                                {key: 'customerName', label: 'Customer Matchcode'},
                                {key: 'customerOrderNumber', label: 'Order Number'},
                                {key: 'orderNumber', label: 'PB Order Number'},
                                {key: 'color', label: 'Color'},
                                {key: 'size', label: 'Size'},
                                {key: 'quantity', label: 'Quantity'},]">
                  <template v-slot:cell(color)="row">
                     <span v-if="row.item.customerColor">{{ row.item.customerColor }}</span>
                     <span v-else>{{ row.item.color }}</span>
                  </template>
                  <template v-slot:cell(size)="row">
                     <span v-if="row.item.customerSize">{{ row.item.customerSize }}</span>
                     <span v-else>{{ row.item.size }}</span>
                  </template>
               </b-table>
               <span v-else>There are no orders for this article.</span>
            </b-modal>
         </div>
      </transition>
   </b-container>
</template>
<script>
import {mapActions} from "vuex";
import CustomSelect from "../../components/ui/CustomSelect";
import ImageGallery from "../../components/ImageGallery";
import Spinner from "../../components/ui/Spinner";
import ArticleBase from "./ArticleBase";
import RelatedArticles from "../../components/article/RelatedArticles";
import ArticleDetailsTable from "../../components/article/ArticleDetailsTable";
import ArticleStockTable from "../../components/article/ArticleStockTable";
import RelatedMoods from "../../components/article/RelatedMoods";
import SampleConfirmationModal from "../../components/SampleConfirmationModal";
import ContactModal from "../../components/ui/ContactModal";
import ArticleDebugOutputModal from "../../components/ArticleDebugOutputModal";
import OrderApi from "@shared/_api/order";

export default {
   name: 'pb-article-details',
   extends: ArticleBase,
   data() {
      return {
         orderListFilter: null,
         article: null,
         colorId: null,
         apiError: null,
         submitProcessing: false,
         category: null,
         amount: null,
         detailsVisible: false,
         stockVisible: false,
         loadingOrderList: false,
         orderList: [],
      }
   },
   components: {
      'pb-related-articles': RelatedArticles,
      'pb-related-moods': RelatedMoods,
      'pb-article-details-table': ArticleDetailsTable,
      'pb-article-stock-table': ArticleStockTable,
      'CustomSelect': CustomSelect,
      'ImageGallery': ImageGallery,
      'spinner': Spinner,
      'contact-modal': ContactModal,
      'sample-confirmation-modal': SampleConfirmationModal,
      'debug-modal': ArticleDebugOutputModal
   },
   mounted() {
      this.loadArticleData(this.$route.params.articleId, this.$route.params.variantId, this.$route.params.categoryId, this.$route.params.cardId);
   },
   beforeRouteUpdate(to, from, next) {
      this.loadArticleData(to.params.articleId, to.params.variantId, to.params.categoryId, to.params.cardId);
      next();
   },
   methods: {
      ...mapActions('cart', ['addItem', 'fetchCart']),
      ...mapActions('favorites', ['addFavorite']),
      collectChildNodes(node, childNodes) {
         if (node.childNodes.length > 0) {
            childNodes.push(...node.childNodes.filter(n => n.featureId !== node.featureId));
            node.childNodes.forEach(childNode => {
               this.collectChildNodes(childNode, childNodes)
            })
         }
      },
      loadOrderList() {
         this.loadingOrderList = true;
         OrderApi.fetchOrderList(this.category.id, this.article.id).then(orderList => {
            this.orderList = this.$_.orderBy(orderList, ['orderCreatedAt'], ['desc']);
            this.$refs.orderPositionsModal.show();
         }).finally(() => {
            this.loadingOrderList = false;
         });
      },
      onRequestSample() {
         if (window.$cookies.isKey('hideSamplePopup')) {
            this.onAddToSamples();
         } else {
            this.$refs.sampleConfirmationModal.show({
               article: this.article,
               variant: this.selectedVariant
            });
         }
      },
      isSampleRequestEnabled() {
         return this.user && this.user.externalData;
      },
      validateState(ref) {
         if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.errors.has(ref)
         }
         return null
      },
      toggleDetails() {
         this.stockVisible = false;
      },
      onSelectColor(colorOptionValue) {
         this.selectedColor = Number(colorOptionValue);
         this.loadVariantPrice();
         this.loadGtlArticle();
      },
      onSelectSize(sizeOptionValue) {
         this.selectedSize = Number(sizeOptionValue);
         this.loadVariantPrice();
         this.loadGtlArticle();
      },
      determinePreselectedVariant(variantList) {
         let nosVariant = variantList.find(articleVariation => {
            return articleVariation.neverOutOfStock && articleVariation.neverOutOfStockSize;
         });

         return nosVariant || variantList.find(articleVariation => {
            return articleVariation.articlePrice && articleVariation.articlePrice.calculatedStock > 0;
         });
      },
      loadArticleData(articleId, colorId, categoryId, cardId) {
         this.category = null;
         this.apiError = null;
         this.cardId = cardId;
         this.colorId = colorId;

         return this.loadArticleStub(articleId, categoryId).then((article) => {
            this.$tracker.trackView({label: article.name, type: 'ARTICLE_DETAIL'}, this.user);
            return this.loadArticleCategory(categoryId || article.primaryCategory);
         }).then(() => {
            let preselectedVariant,
                colorspecificVariant;

            this.colorSelectCustomerMode = this.variantList.some(variant => variant.articleColor.customerValue);

            let variantList = this.colorSelectCustomerMode ? this.variantList.filter(variant => variant.articleColor.customerValue) : this.article.variantList;

            // find variant for specific color
            colorspecificVariant = (colorId) ? variantList.find(articleVariation => {
               return (articleVariation.articlePrice && articleVariation.articlePrice.calculatedStock > 0) && (Number(articleVariation.articleColor.id) === Number(colorId));
            }) : null;


            let backupVariant = cardId ? variantList.find(articleVariation => {
               return (Number(articleVariation.articleColor.id) === Number(colorId));
            }) : variantList[0];

            preselectedVariant = (colorspecificVariant || this.determinePreselectedVariant(variantList)) || backupVariant;

            this.onSelectColor(preselectedVariant.articleColor.id);
            this.onSelectSize(preselectedVariant.articleSize.id);

            return Promise.resolve();
         }).catch(error => {
            if (error.status === 403 || error.status === 404) {
               this.$router.push({
                  name: 'basic',
                  params: {articleId: articleId}
               });
               return;
            }
            if (error.status === 403) {
               this.apiError = "Access is denied. You may not have the appropriate permissions to access the requested product data."
            } else if (error.status === 404) {
               this.apiError = "We could not find the requested article"
            } else {
               this.apiError = error;
            }
         }).then(() => {
            this.articleLoading = false;
            return this.loadArticleVariantList(articleId, categoryId);
         })
      }
   },
   computed: {
      loadingArticle() {
         return this.loadingArticleCategory || this.loadingArticleStub;
      },
      articleDetails() {
         return this.article;
      },
      rawComponents: function () {
         return (this.articlePrice.rawComponents > 0) ? this.articlePrice.stock : 0;
      },
      gtlAttributes() {
         let res = [];
         if (this.selectedVariant && this.selectedVariant.gtlArticle) {
            let attributes = this.selectedVariant.gtlArticle.attributes;
            JSON.parse(this.$config['tree']).forEach(jsonNode => {
               let existingAttributes = [];
               jsonNode.features.forEach(featureId => {
                  let attribute = attributes.find(attribute => attribute.feature.id === featureId);

                  if (attribute) {
                     existingAttributes.push(attribute)
                  }
               });
               if (existingAttributes.length > 0) {

                  res.push({
                     description: jsonNode.decription,
                     attributes: existingAttributes
                  });
               }
            })
         }
         // if (this.selectedVariant && this.selectedVariant.gtlArticle) {
         //     let attributes = this.$_.cloneDeep(this.selectedVariant.gtlArticle.structuredAttributes);
         //     attributes.forEach(node => {
         //         let childNodes = [];
         //         this.collectChildNodes(node, childNodes);
         //         node.childNodes = childNodes.filter(n => n.articleAttribute);
         //         res.push(node);
         //     })
         // }

         return res;
      },
   },
   watch: {
      user: function (user) {
         this.loadArticleData(this.$route.params.articleId, this.$route.params.variantId, this.$route.params.categoryId, this.$route.params.cardId);
      }
   }
}
</script>
<style lang="scss" scoped>

@import "~@shared/_assets/scss/constants";

.article-row {
   margin-top: 120px;
   @include media-breakpoint-down(md) {
      margin-top: 60px;
   }
}

.article-stock-collapsible {
   overflow-x: auto;
}

.article-details {
   .article-info {
      position: relative;

   }

   .article-details-toggle-btn {
      .when-opened {
         display: none;
      }

      .when-closed {
         display: inline-block;
      }

      &.collapsed {
         .when-opened {
            display: inline-block;
         }

         .when-closed {
            display: none;
         }
      }
   }

   .article-document-section {
      a {
         text-transform: uppercase;
      }
   }

   .info-box, a {
      font-size: 15px;
      letter-spacing: 1.5px;
      font-family: $font-muli;
      color: $color-primary-dark;
      font-weight: 300;

      a:hover {
         font-weight: bold;
      }
   }

   .price-block {
      font-size: 18px;
      letter-spacing: 1.5px;
      font-family: $font-muli;
      color: $color-primary
   }


}
</style>